export const defaultOpsClockHeaders = [
  "Activity",
  "Breakfast",
  "Brunch",
  "Lunch",
  "Dinner",
  "Bedtime",
];

export const opsClockActivities = {
  "Injection CET-1": "CET 1",
  "Injection CET-2": "CET 2",
  AST: "AST",
  "CPT Clear Time": "CPT Clear Time",
  "Induct Guardrail (Earliest Induct)": "Induct Guardrail",
  "SSD Order Start (Charge Cutoff)": "Charge Cut Off",
  "SSD Order Cutoff (Customer Cutoff)": "Customer Cutoff",
  "CPT Time": "CPT",
  "Induct Complete (SSD)": "Induct Complete",
  "Sortation Complete": "Sortation Complete",
  "Final Stage": "Final Stage",
  "VNA Start Time": "VNA Start Time",
};

export const groceryOpsClock = {
  "Ambient Pick Start": "Ambient Pick Start",
  "Chilled/Frozen Pick Start": "Chilled/Frozen Pick Start",
  "Induct Grocery Guardrail (Earliest Induct)": "Induct Grocery Guardrail",
  "Grocery Order Start (Charge Cutoff)": "Grocery Charge Cut Off",
  "Grocery Order Cutoff (Customer Cutoff)": "Grocery Customer Cutoff",
  "Grocery CPT Time": "Grocery CPT",
  "Stow Complete": "Stow Complete",
  "Grocery Induct Complete (SSD)": "Grocery Induct Complete",
  "Grocery Batching Start": "Grocery Batching Start",
  "Grocery First Dispatch": "Grocery First Dispatch",
  "Grocery Final Dispatch": "Grocery Final Dispatch",
};

export const nonEditableOpsClockActivities = [
  "Delivery Window Start",
  "Delivery Window End",
];

export const defaultTime = " -- : --";

export const activityTemplate = {
  window_list: [
    {
      name: "Breakfast",
      time: null,
    },
    {
      name: "Brunch",
      time: null,
    },
    {
      name: "Lunch",
      time: null,
    },
    {
      name: "Dinner",
      time: null,
    },
    {
      name: "Bedtime",
      time: null,
    },
  ],
  label: null,
  order: 0,
  name: null,
};

export const singles_flag = "singles_enabled";
export const grocery_enabled_flag = "grocery_enabled";
export const grocery_charge_split_flag = "grocery_charge_split";
export const rush_enabled_flag = "rush_enabled";
export const rush_indirect_rules_enabled = "rush_indirect_rules_enabled";

export const BUSINESS_TYPES = {
  CORE: "core",
  GROCERY: "grocery",
};

export const SPEED_TYPES = {
  FIVE_HOUR: "5H",
  THREE_HOUR: "3H",
  ONE_HOUR: "1H",
};



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/SsdSettingsConstant.js